import * as i from "react";
import { P as p, c as g, a as B, b as H, d as V, u as q } from "./index-wif4gfZf.js";
import { u as R } from "./index-DLcqcWxM.js";
import { u as C } from "./index-Cv867SGx.js";
import { P as K, D as U } from "./index-B9Qoa2iP.js";
import { R as Y, h as Z, u as z, F as J } from "./Combination-CNeqR4sO.js";
import { P as _ } from "./index-BpWB3aFK.js";
import { j as s } from "./utils-BdNIfrGQ.js";
var m = "Dialog", [y] = B(m), [Q, u] = y(m), N = (e) => {
  const {
    __scopeDialog: o,
    children: r,
    open: a,
    defaultOpen: n,
    onOpenChange: t,
    modal: l = !0
  } = e, c = i.useRef(null), f = i.useRef(null), [v, x] = q({
    prop: a,
    defaultProp: n ?? !1,
    onChange: t,
    caller: m
  });
  return /* @__PURE__ */ s.jsx(
    Q,
    {
      scope: o,
      triggerRef: c,
      contentRef: f,
      contentId: C(),
      titleId: C(),
      descriptionId: C(),
      open: v,
      onOpenChange: x,
      onOpenToggle: i.useCallback(() => x(($) => !$), [x]),
      modal: l,
      children: r
    }
  );
};
N.displayName = m;
var O = "DialogTrigger", I = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: r, ...a } = e, n = u(O, r), t = R(o, n.triggerRef);
    return /* @__PURE__ */ s.jsx(
      p.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": P(n.open),
        ...a,
        ref: t,
        onClick: g(e.onClick, n.onOpenToggle)
      }
    );
  }
);
I.displayName = O;
var h = "DialogPortal", [X, A] = y(h, {
  forceMount: void 0
}), T = (e) => {
  const { __scopeDialog: o, forceMount: r, children: a, container: n } = e, t = u(h, o);
  return /* @__PURE__ */ s.jsx(X, { scope: o, forceMount: r, children: i.Children.map(a, (l) => /* @__PURE__ */ s.jsx(_, { present: r || t.open, children: /* @__PURE__ */ s.jsx(K, { asChild: !0, container: n, children: l }) })) });
};
T.displayName = h;
var D = "DialogOverlay", b = i.forwardRef(
  (e, o) => {
    const r = A(D, e.__scopeDialog), { forceMount: a = r.forceMount, ...n } = e, t = u(D, e.__scopeDialog);
    return t.modal ? /* @__PURE__ */ s.jsx(_, { present: a || t.open, children: /* @__PURE__ */ s.jsx(te, { ...n, ref: o }) }) : null;
  }
);
b.displayName = D;
var ee = H("DialogOverlay.RemoveScroll"), te = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: r, ...a } = e, n = u(D, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ s.jsx(Y, { as: ee, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ s.jsx(
        p.div,
        {
          "data-state": P(n.open),
          ...a,
          ref: o,
          style: { pointerEvents: "auto", ...a.style }
        }
      ) })
    );
  }
), d = "DialogContent", j = i.forwardRef(
  (e, o) => {
    const r = A(d, e.__scopeDialog), { forceMount: a = r.forceMount, ...n } = e, t = u(d, e.__scopeDialog);
    return /* @__PURE__ */ s.jsx(_, { present: a || t.open, children: t.modal ? /* @__PURE__ */ s.jsx(oe, { ...n, ref: o }) : /* @__PURE__ */ s.jsx(ne, { ...n, ref: o }) });
  }
);
j.displayName = d;
var oe = i.forwardRef(
  (e, o) => {
    const r = u(d, e.__scopeDialog), a = i.useRef(null), n = R(o, r.contentRef, a);
    return i.useEffect(() => {
      const t = a.current;
      if (t) return Z(t);
    }, []), /* @__PURE__ */ s.jsx(
      M,
      {
        ...e,
        ref: n,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: g(e.onCloseAutoFocus, (t) => {
          t.preventDefault(), r.triggerRef.current?.focus();
        }),
        onPointerDownOutside: g(e.onPointerDownOutside, (t) => {
          const l = t.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0;
          (l.button === 2 || c) && t.preventDefault();
        }),
        onFocusOutside: g(
          e.onFocusOutside,
          (t) => t.preventDefault()
        )
      }
    );
  }
), ne = i.forwardRef(
  (e, o) => {
    const r = u(d, e.__scopeDialog), a = i.useRef(!1), n = i.useRef(!1);
    return /* @__PURE__ */ s.jsx(
      M,
      {
        ...e,
        ref: o,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (t) => {
          e.onCloseAutoFocus?.(t), t.defaultPrevented || (a.current || r.triggerRef.current?.focus(), t.preventDefault()), a.current = !1, n.current = !1;
        },
        onInteractOutside: (t) => {
          e.onInteractOutside?.(t), t.defaultPrevented || (a.current = !0, t.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const l = t.target;
          r.triggerRef.current?.contains(l) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && n.current && t.preventDefault();
        }
      }
    );
  }
), M = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: r, trapFocus: a, onOpenAutoFocus: n, onCloseAutoFocus: t, ...l } = e, c = u(d, r), f = i.useRef(null), v = R(o, f);
    return z(), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        J,
        {
          asChild: !0,
          loop: !0,
          trapped: a,
          onMountAutoFocus: n,
          onUnmountAutoFocus: t,
          children: /* @__PURE__ */ s.jsx(
            U,
            {
              role: "dialog",
              id: c.contentId,
              "aria-describedby": c.descriptionId,
              "aria-labelledby": c.titleId,
              "data-state": P(c.open),
              ...l,
              ref: v,
              onDismiss: () => c.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(re, { titleId: c.titleId }),
        /* @__PURE__ */ s.jsx(se, { contentRef: f, descriptionId: c.descriptionId })
      ] })
    ] });
  }
), E = "DialogTitle", F = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: r, ...a } = e, n = u(E, r);
    return /* @__PURE__ */ s.jsx(p.h2, { id: n.titleId, ...a, ref: o });
  }
);
F.displayName = E;
var w = "DialogDescription", S = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: r, ...a } = e, n = u(w, r);
    return /* @__PURE__ */ s.jsx(p.p, { id: n.descriptionId, ...a, ref: o });
  }
);
S.displayName = w;
var W = "DialogClose", k = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: r, ...a } = e, n = u(W, r);
    return /* @__PURE__ */ s.jsx(
      p.button,
      {
        type: "button",
        ...a,
        ref: o,
        onClick: g(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
k.displayName = W;
function P(e) {
  return e ? "open" : "closed";
}
var G = "DialogTitleWarning", [pe, L] = V(G, {
  contentName: d,
  titleName: E,
  docsSlug: "dialog"
}), re = ({ titleId: e }) => {
  const o = L(G), r = `\`${o.contentName}\` requires a \`${o.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${o.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${o.docsSlug}`;
  return i.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, ae = "DialogDescriptionWarning", se = ({ contentRef: e, descriptionId: o }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${L(ae).contentName}}.`;
  return i.useEffect(() => {
    const n = e.current?.getAttribute("aria-describedby");
    o && n && (document.getElementById(o) || console.warn(a));
  }, [a, e, o]), null;
}, De = N, me = I, ve = T, xe = b, Ce = j, Re = F, _e = S, he = k;
export {
  Ce as C,
  _e as D,
  xe as O,
  ve as P,
  De as R,
  Re as T,
  he as a,
  me as b
};
